import React, { Component } from 'react';
import './ConfirmData.css';
import logoblue from '../../../image/logoblue.png'
import { Link } from 'react-router-dom';
import Navbar from '../Components/Navbar/Navbar'
import iconrightgreen from '../../../image/iconrightgreen.svg'
import axios from 'axios'
import { LinkAPI } from '../../../API/API'
import HandleRes from '../Components/HandleRes/HandleRes';

class Confirmmaildone extends Component {
 
    constructor(props) {
        super(props);
        this.state = {
            res_confirmemail:true,
            networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            hasError: false,
        }
    }
    componentDidMount(){
        this.confirmchangeemail()

    }
    confirmchangeemail=()=>{
        const Token = this.props.match.params.Token 
        axios.put(`${LinkAPI}/api/businessowner/confirmchangeemail`,{},{
            headers:{
              Authorization:`${Token}`,
              lang:"ar"
            }
          }).then(res =>{
            localStorage.setItem("userToken",res.data.token)
            this.setState({
                res_confirmemail: false,
                networkError: false,
                errordatamessage: false,
                errordatamessagetext: '',
                hasError: false,
                        })
                        setTimeout(() => {
                            window.location.replace("/AR/orders");
                    }, 1000);
                    localStorage.removeItem("AdminTokenKayn")

            }).catch(error=>{
                if (!error.response) {
                    this.setState({
                        networkError: true
                    })
                } else if (error.response.status === 402) {
                    localStorage.removeItem("userToken")
                    window.location.replace("/AR/SignIn");
                } else if (error.response.data.message) {
                    this.setState({
                        errordatamessage: true,
                        errordatamessagetext: error.response.data.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
            })
          }
    render() {
        document.title ="kayn | تاكيد البريد الاكتروني  ";
      document.getElementsByTagName("META")[1].content="كاين | تاكيد البريد الاكتروني     ";
      document.documentElement.lang = 'ar';
        return (
            <div className="AppAR ConfirmData">
                <Navbar />
                <div className='container'>
                {(this.state.res_confirmemail?'':
                    <div className="Sign  row">
                       
                        <div className="col-md-6 form text-center p-lg-5 ">
                        <div className=" mx-auto  text-center textconfirm">
                        <img className="mt-2 warningimg" src={iconrightgreen} alt="warning" />
                            <p className="fontsize9 py-2">تم التاكد من البريد الاكتروني</p>
                        </div>
                       
                        </div>
                        <div className="logoform col-6 d-flex align-content-end flex-wrap">
                            <div className="col-12 text-center mt-auto p-2 bd-highlight"><Link to="/AR/"><img className="logo" src={logoblue} alt="kayn" /></Link>       </div>
                            <p className="fontsize2 text-center mb-5 col-12">طلبك الخاصة بك ... طريقك</p>
                        </div>
                    </div>)}
                </div>
                {(this.state.errordatamessage ? <HandleRes title={this.state.errordatamessagetext} stylecss="alert-danger" /> : '')}
                {(this.state.networkError ? <HandleRes title="تاكد باتصالك بالانترنت ثم عاود المحاوله" stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="  هناك مشكلة في طلبك" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}
export default Confirmmaildone;